export default __webpack_public_path__ + "static/media/img2.096ed0a3.png";